<!-- =========================================================================================
  File Name: ExhibitorList.vue
  Description: Exhibitor List Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
</style>
<template>
  <div id="page-user-list">
    <div class="header-custome">
      <h3>Tags Category Master</h3>
    </div>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ mailtplData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : mailtplData.length }} of {{ mailtplData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <vs-button type="gradient mr-4" v-on:click="addRecord ()">Add Tags Category</vs-button>
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Delete</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Archive</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Print</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>CSV</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="TagsData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

// Store Module
import moduleMailtplManagement from "@/store/mailtpl-management/moduleMailtplManagement.js";
import bu from "@/store/bulkupload/BulkUpload.js";

// Cell Renderer
// import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
// import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
// import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import TagsCellRendererActions from "./TagsCellRendererActions.vue";
import ls from "@/common/localStorage";
import con from "@/firebase/firebaseInit.ts";
//console.log(db);

export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    // CellRendererLink,
    // CellRendererStatus,
    // CellRendererVerified,
    TagsCellRendererActions,
  },
  data() {
    return {
      TagsData: [],
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: "ID",
          field: "CatID",
          filter: true,
          width: 200,
        },
        {
          headerName: "Category Name",
          field: "CatName",
          width: 600,
          cellRendererParams: (params) => {
            return {
              DocName: params.data.DocName,
              CollectionName: params.data.CollectionName,
            };
          },
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 150,
          cellRendererFramework: "TagsCellRendererActions",
          cellRendererParams: (params) => {
            return { id: params.data.CatID };
          },
        },
      ],

      // Cell Renderer Components
      components: {
        // CellRendererLink,
        // CellRendererStatus,
        // CellRendererVerified,
        TagsCellRendererActions,
      },
    };
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter("role", obj.value);
    },
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value);
    },
    isVerifiedFilter(obj) {
      const val =
        obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
      this.setColumnFilter("is_verified", val);
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value);
    },
  },
  computed: {
    mailtplData() {
      return this.$store.state.mailtplManagement.mailtpls;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        // this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    addRecord() {
      this.$router
        .push({
          name: "instancetagsedit",
          params: {
            CatID: 0,
          },
        })
        .catch(() => {});
    },
    // editRecord () {
    //   this.$router.push(`/event/exhibitor/add/${268}`).catch(() => {})
    // },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all",
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    //-----------GEt Category Listing------------------------------------------------------------------------------

    var cn = ls.getSessionEventCollectionName(); ///OA_UAT/BoothDesigns/Templates/2A1wtx9POQHMNWUlJ0PF
    var cref2 = con.eventDB
      .collection("OA_UAT")
      .doc("TagCategories")
      .collection("CategoryList");

    cref2.get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.TagsData.push({
          CatID: doc.data().CatID,
          CatName: doc.data().CatName,
        });
      });
      console.log(this.TagsData);
    });
    //-----------------------------------------------------------------------------------------------------------
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    if (!moduleMailtplManagement.isRegistered) {
      this.$store.registerModule("mailtplManagement", moduleMailtplManagement);
      moduleMailtplManagement.isRegistered = true;
    }
    this.$store.dispatch("mailtplManagement/fetchMailtpls").catch((err) => {
      console.error(err);
    });
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>